import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../pages/Home.vue';
import login from '../pages/login.vue';
import logout from '../pages/logout.vue';
import Exhibitor_form from "../pages/Exhibitor_form";
import ProgramApplication from "../pages/ProgramApplication";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/logout',
        component: logout,
        name: 'logout',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:name/apply',
        component: ProgramApplication,
        name: 'attendance',
        // meta: {
        //     requiresAuth: true
        // }
    },

    {
        path: '/exhibit-form',
        name: 'Exhibit',
        component: Exhibitor_form,
    },

    {
        path: "/404", component: () => import('../pages/errorPage.vue'),
    },
    {
        path: "*",
        redirect: "/404"
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;
